module.exports = __webpack_public_path__ + "img/6530.5e475f49.jpg";